"use client";

import { MaterialIcon } from "@website/icons/material";
import { useAccordionItem } from "@website/website-ui/accordion/accordion.hook";
import { AccordionPropertiesType } from "@website/website-ui/accordion/accordion.types";
import { FC } from "react";

const Accordion: FC<AccordionPropertiesType> = (properties) => {
  const {
    expanded,
    buttonProperties,
    contentWrapperProperties,
    detailsProperties,
    summeryProperties
  } = useAccordionItem(properties);
  const {
    content,
    disabled,
    title,
    subtitle,
    variant = "outline",
    scroll,
    StartIcon
  } = properties;

  return (
    <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
      <details
        {...detailsProperties}
        className={`border-outline-thin bg-background flex flex-col ${
          variant === "outline" ? "rounded border" : "border-b"
        }`}
      >
        <summary
          {...summeryProperties}
          className={`flex min-h-[48px] min-w-0 cursor-pointer items-center justify-between gap-4 px-3 text-start font-medium ${
            disabled ?? "cursor-not-allowed"
          }`}
        >
          <h3
            className="text-on-surface-high-emphasis text-subtitle-1 mx-2 flex flex-row items-center gap-[10px] py-3"
            itemProp="name"
          >
            {StartIcon ? (
              <div
                className={`size-6 shrink-0 overflow-hidden text-2xl leading-6 ${
                  disabled ?? "text-on-surface-disable"
                }`}
              >
                {StartIcon}
              </div>
            ) : null}
            <span className="lg:text-subtitle-1 text-subtitle-2">{title}</span>
          </h3>
          {subtitle && (
            <span
              className={`ml-4 ${
                disabled
                  ? "text-on-surface-medium-emphasis"
                  : "text-on-surface-disable"
              }`}
            >
              {subtitle}
            </span>
          )}
          <button
            className="text-secondary hover:bg-outline-thick flex size-8 items-center justify-center rounded-md text-2xl outline-0"
            {...buttonProperties}
          >
            {expanded ? (
              <MaterialIcon name="keyboard_arrow_up" variant="outlined" />
            ) : (
              <MaterialIcon name="keyboard_arrow_down" variant="outlined" />
            )}
          </button>
        </summary>
        <div
          itemProp="acceptedAnswer"
          itemScope
          itemType="https://schema.org/Answer"
          {...contentWrapperProperties}
          className="overflow-hidden text-start font-normal transition-all"
        >
          <div
            className={`text-on-surface-medium-emphasis text-body-2 px-4 py-3 ${
              scroll === "long"
                ? "max-h-[272px] overflow-auto"
                : scroll === "short"
                  ? "max-h-[272px] overflow-auto xl:max-h-[112px]"
                  : ""
            }`}
            itemProp="text"
          >
            {content}
          </div>
        </div>
      </details>
    </div>
  );
};

export default Accordion;
